module.exports = __webpack_public_path__ + "static/r18-5b5e9c921893f3cacc2bb19f3790b374.jpg";